import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";

// Adapted from ITEPerformanceLevel: kit type is the equivalent top-level
// choice for a Switch on Kit order.
const SwitchOnKitType = ({ rightSelected, leftSelected, getOptionsForSide, allowedValues, selectedOptions, setOption }) => {
  const option = getOptionsForSide(rightSelected ? "R" : "L").find((entry) => entry.Code === "AB_KIT_TYPE");
  if (!option || (!rightSelected && !leftSelected)) return null;
  const side = rightSelected ? "R" : "L";
  const selected = selectedOptions[side][option.Name];

  return <div className="performance-level-component-main-div order-builder-component switch-on-kit-type">
    <Row className="order-builder-component-title">
      <Col xs={12}><h2>Choose a kit type</h2></Col>
      {allowedValues(option, side).map((value) => <Col key={value} md={3}>
        <button type="button" className="switch-on-kit-type-button" onClick={() => setOption(side, option, value)}>
          <div className={`performance-level-box ${selected === value ? "active" : ""}`}><div className="performance-level-box-text"><p>{value}</p></div></div>
        </button>
      </Col>)}
    </Row>
  </div>;
};

SwitchOnKitType.propTypes = {
  rightSelected: PropTypes.bool, leftSelected: PropTypes.bool, getOptionsForSide: PropTypes.func,
  allowedValues: PropTypes.func, selectedOptions: PropTypes.object, setOption: PropTypes.func,
};
export default SwitchOnKitType;
